import { styled } from '@linaria/react';

import { MqTablet } from '~theme/media';

export const SideMenuContainer = styled.div<{ isOpen: boolean }>`
	position: fixed;
	z-index: 50;
	right: 1rem;
	bottom: calc(6rem + var(--safe-bottom));
	display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
	width: 30.2rem;
	height: calc(100% - 12rem - var(--safe-top));

	${MqTablet} {
		top: calc(6rem + var(--header-offset) + var(--safe-top));
		right: auto;
		bottom: auto;
		left: 1rem;
		height: calc(100% - 12rem - var(--header-offset));
	}
`;
